<template>
  <div styleName="screenWrap">
    这是屏幕共享
  </div>
</template>
<script>
import styles from './index.scss'
import CSSModules from 'vue-css-modules'

export default {
  name: 'modal',
  mixins: [CSSModules(styles)],
  computed: {
  }
}
</script>
